import {Tooltip} from 'platform/components';

import type {ReactNode} from 'react';

export type TruncatedCellTooltipProps = {
  /** What the tooltip shows — plain text, or rich content (e.g. flag badges). */
  label: ReactNode;
};

/**
 * Truncation tooltip rendered as an absolutely-positioned sibling of the cell
 * content instead of wrapping it. Wrapping the content in <Tooltip> would
 * remount it the moment the tooltip opens (Tooltip renders bare children until
 * it has a label), re-instantiating renderers and dropping any in-progress
 * text selection. The anchor mirrors the cell's box (inset-0) so floating-ui
 * positions the bubble against the cell; pointer-events-none keeps the pointer
 * hitting the cell underneath; the inner tabIndex={-1} span keeps the Tooltip
 * children wrapper from becoming a tab stop while the tooltip is open.
 */
export function TruncatedCellTooltip(props: TruncatedCellTooltipProps) {
  return (
    <div className="pointer-events-none absolute inset-0">
      <Tooltip isOpen placement="top" label={props.label}>
        <span tabIndex={-1} className="block h-full w-full" />
      </Tooltip>
    </div>
  );
}
